import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/theme/theme-darkblue/index.css'
import VueRouter from 'vue-router'
import routes from './routes'
import 'font-awesome/css/font-awesome.min.css'

Vue.use(ElementUI)
Vue.use(VueRouter)

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
    console.log(to)
    if (to.path !== '/') {
        next({ path: '/', params: to.params })
    } else {
        next();
    }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js